// Usuwanie zgłoszenia wsparcia z panelu super-admina.
//
// RLS: DELETE przepuszcza wyłącznie polityka `support_tickets_super_admin`
// (`is_super_admin()`, polcmd '*'); zwykły najemca i partner nie mają polityki
// DELETE wcale. PostgREST nie zgłasza wtedy błędu — DELETE zablokowany przez
// RLS wraca z pustą listą wierszy i status 200 — więc samo `error === null`
// NICZEGO nie dowodzi. Dlatego usuwamy z `.select('id')` i liczymy wiersze:
// zero wierszy to porażka (brak uprawnień albo zgłoszenie już nie istnieje),
// a rozróżnić się ich z klienta nie da.
//
// `ticket_messages` znikają kaskadą (FK ON DELETE CASCADE), ankiety
// `partner_surveys.ticket_id` dostają NULL (ON DELETE SET NULL) — ocena
// partnera przeżywa sprzątnięcie zgłoszenia i tak ma być.

interface WynikZapytania {
  data: { id: string }[] | null;
  error: { message?: string } | null;
}

/** Minimalny wycinek klienta Supabase, jakiego potrzebuje usunięcie. */
export interface KlientUsuwania {
  from(table: string): {
    delete(): {
      eq(
        column: string,
        value: string
      ): {
        select(columns: string): PromiseLike<WynikZapytania>;
      };
    };
  };
}

export type WynikUsuniecia = { ok: true } | { ok: false; komunikat: string };

export async function usunZgloszenie(
  klient: KlientUsuwania,
  ticketId: string
): Promise<WynikUsuniecia> {
  let wynik: WynikZapytania;
  try {
    wynik = await klient.from('support_tickets').delete().eq('id', ticketId).select('id');
  } catch {
    return { ok: false, komunikat: 'Nie udało się usunąć zgłoszenia — błąd połączenia' };
  }

  if (wynik.error) {
    return {
      ok: false,
      komunikat: wynik.error.message
        ? `Nie udało się usunąć zgłoszenia: ${wynik.error.message}`
        : 'Nie udało się usunąć zgłoszenia',
    };
  }

  if (!wynik.data || wynik.data.length === 0) {
    return {
      ok: false,
      komunikat:
        'Zgłoszenie nie zostało usunięte — brak uprawnień albo zgłoszenie już nie istnieje',
    };
  }

  return { ok: true };
}
